export class BaseOptionModel {
	public label: string;
	public value: string | number;
}
